import Numbers from './Numbers';
/**
 * A group three numbers, this component will deal with three zero numbers
 */
export default class Zerofill extends Numbers {
    read(firstNumber) {
        if (this.first !== '0' || this.second !== '0' || this.last !== '0') {
            return `${super.read(firstNumber)} ${this.unitName}`;
        }
        else {
            return '';
        }
    }
}
